import { Component } from '@angular/core';

@Component({
  selector: 'app-ingresscharts',
  templateUrl: './ingresscharts.component.html',
  styleUrls: ['./ingresscharts.component.scss']
})
export class IngresschartsComponent {

}
